// extracted by mini-css-extract-plugin
export default {"subtitle-wrapper":"LocationAndTime--subtitle-wrapper--6yH0n","subtitleWrapper":"LocationAndTime--subtitle-wrapper--6yH0n","location":"LocationAndTime--location--Djc4K"};